export default __webpack_public_path__ + "static/media/sign.a1fb04d3.jpg";